<label
  class="sg-toggle sg-ui-component"
  [class.sg-toggle--checked]="checked"
  [class.sg-toggle--disabled]="disabled"
  [class.sg-toggle--focused]="focused"
  [class.sg-toggle--size-default]="size === 'default'"
  [class.sg-toggle--size-small]="size === 'small'">
  <input
    #inputEl
    type="checkbox"
    role="switch"
    class="sg-toggle__input"
    [checked]="checked"
    [disabled]="disabled"
    [attr.aria-checked]="checked"
    [attr.aria-disabled]="disabled"
    (change)="onInputChange($event)" />
  <span class="sg-toggle__track"><span class="sg-toggle__thumb"></span></span>
  @if (label || hasContent) {
  <span class="sg-toggle__label">
    <sg-text variant="sg-label-medium-regular">
      @if (label) { {{ label }} }
      <ng-content></ng-content>
    </sg-text>
  </span>
  }
</label>
